const serverURL = import.meta.env.VITE_API_URL

export async function fetchIwi(token: string) {
  const response = await fetch(`${serverURL}/iwi/`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }

  const iwi = await response.json()

  return iwi
}
